import React, { useState } from 'react';
import { FaExclamationTriangle, FaEnvelopeOpen } from 'react-icons/fa';
import classNames from 'classnames/bind';

import { MailchimpWrap, MailchimpInner } from './mailchimp.styles';
import styles from './mailchimp.module.scss';

const cx = classNames.bind(styles);

interface MailchimpFormProps {
  status: string;
  message: string;
  onValidated: (param: any) => void;
  setSuccess: (value: boolean) => void;
  backgroundTheme: 'light' | 'dark';
}

export const MailchimpForm: React.FC<MailchimpFormProps> = ({
  status,
  message,
  onValidated,
  setSuccess,
  backgroundTheme,
}) => {
  const [alreadySuccess, setAlreadySuccess] = useState(false);
  const [error, setError] = useState(false);
  let email;
  const submit = () => {
    const isValidate = validateEmail(email.value);
    setError(!isValidate);
    if (isValidate) {
      return (
        email &&
        email.value.indexOf('@') > -1 &&
        onValidated({
          EMAIL: email.value,
        })
      );
    }
  };

  function validateEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  if (status === 'success' && !error && !alreadySuccess) {
    setAlreadySuccess(true);
    setSuccess(true);
  }

  return (
    <MailchimpWrap>
      <MailchimpInner>
        <div className={cx('inputWrapper', { error })}>
          <span className={cx('icon')}>
            <FaEnvelopeOpen />
          </span>
          <input
            ref={(node) => (email = node)}
            type="email"
            placeholder="Enter Your Email Address"
            aria-label="Enter Your Email Address"
            className={cx('input')}
          />
        </div>
        {error && !status && (
          <div className={cx('text', backgroundTheme)}>
            <FaExclamationTriangle style={{ marginRight: 8 }} size={24} />
            Please, enter a valid email
          </div>
        )}
        {status === 'error' && !error && (
          <div className={cx('text', backgroundTheme)}>
            <FaExclamationTriangle style={{ marginRight: 8 }} size={24} />
            <span dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        )}
        <button
          onClick={submit}
          type="submit"
          className={styles.button}
          disabled={status === 'sending' && !error}
        >
          {status === 'sending' && !error ? `Sending...` : `Submit`}
        </button>
      </MailchimpInner>
    </MailchimpWrap>
  );
};
